var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-743.000000, -1365.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "\\uF017"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.5,1365 C756.195565,1365 760,1368.80444 760,1373.5 C760,1378.19556 756.195565,1382 751.5,1382 C746.804435,1382 743,1378.19556 743,1373.5 C743,1368.80444 746.804435,1365 751.5,1365 Z M751.5,1380.35484 C755.287298,1380.35484 758.354839,1377.2873 758.354839,1373.5 C758.354839,1369.7127 755.287298,1366.64516 751.5,1366.64516 C747.712702,1366.64516 744.645161,1369.7127 744.645161,1373.5 C744.645161,1377.2873 747.712702,1380.35484 751.5,1380.35484 Z M753.618138,1376.7766 L750.70828,1374.66191 C750.602009,1374.58305 750.540323,1374.45968 750.540323,1374.32944 L750.540323,1368.70161 C750.540323,1368.47542 750.725417,1368.29032 750.951613,1368.29032 L752.048387,1368.29032 C752.274583,1368.29032 752.459677,1368.47542 752.459677,1368.70161 L752.459677,1373.55827 L754.749187,1375.22399 C754.934281,1375.35767 754.971969,1375.61472 754.83832,1375.79978 L754.193938,1376.6875 C754.060289,1376.86915 753.803233,1376.91028 753.618138,1376.7766 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.04f387bc.svg";
export { ForwardRef as ReactComponent };